"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function _default(theme, _ref) {
  var focus = _ref.focus;
  var palette = theme.palette;
  var height;
  var lineHeight = theme.lineHeight;
  height = (typeof lineHeight === 'number' ? (0, _pixelToNumber["default"])(theme.fontSize) * lineHeight : (0, _pixelToNumber["default"])(lineHeight)) + (0, _pixelToNumber["default"])(theme.paddingTop) + (0, _pixelToNumber["default"])(theme.paddingBottom);
  return {
    wrapper: {
      position: 'relative'
    },
    search: {
      position: 'absolute',
      width: theme.searchIconWidth,
      height: height,
      left: 0,
      bottom: 0,
      transition: "opacity ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      opacity: focus ? 0.87 : 0.38,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    clear: {
      position: 'absolute',
      width: theme.clearIconWidth,
      height: height,
      right: 0,
      bottom: 0,
      transition: "opacity ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
      opacity: 0.38,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      '&:hover': {
        opacity: 0.87
      }
    },
    input: {
      paddingLeft: palette.gutter * 4 + 'px',
      paddingRight: palette.gutter * 4 + 'px',
      width: '100%'
    }
  };
}